module.exports = __webpack_public_path__ + "static/media/payment-vector.227ea464.svg";